'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'ufo-beam';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e048';
var svgPathData = ['M44.3 498.3c-7.5 10.9-4.8 25.8 6.1 33.4s25.8 4.8 33.4-6.1l72-104c7.5-10.9 4.8-25.8-6.1-33.4s-25.8-4.8-33.4 6.1l-72 104zM128 157.1s47.1 50.9 160 50.9 160-50.9 160-50.9c0-14.1-1.6-27.7-4.5-40.8-17-75.9-80.2-132.2-155.5-132.2S149.4 40.4 132.5 116.2c-2.9 13.1-4.5 26.8-4.5 40.8zM420.3 421.7l72 104c7.5 10.9 22.5 13.6 33.4 6.1s13.6-22.5 6.1-33.4l-72-104c-7.5-10.9-22.5-13.6-33.4-6.1s-13.6 22.5-6.1 33.4z', 'M288 208c112.9 0 160-50.9 160-50.9 0-14.1-1.6-27.7-4.5-40.8 79.7 22.8 132.5 62.5 132.5 107.8 0 70.7-128.9 128-288 128S0 294.7 0 224c0-45.2 52.8-85 132.5-107.8-2.9 13.1-4.5 26.8-4.5 40.8 0 0 47.1 50.9 160 50.9zm24 64a24 24 0 1 0 -48 0 24 24 0 1 0 48 0zm-192-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48zm360-24a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUfoBeam = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;